/*
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description:
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import restApi from '../api/restapi';
const Home = () => import('@/views/Home');
const Login = () => import('@/views/Login');
const Conversations = () => import('@/views/Conversations');
const Contacts = () => import('@/views/Contacts');
const PrivateChat = () => import('@/views/PrivateChat');
const GroupChat = () => import('@/views/GroupChat');
const ShareCard = () => import('@/views/ShareCard');
const VideoList = () => import('@/views/VideoList');
const Report = () => import('@/views/Report');
const LossChange = () => import('@/views/lossChange');
const Rank = () => import('@/views/Rank');
const SQRank = () => import('@/views/SQRank');
const WeightChart = () => import('@/views/WeightChart');
const EducationInfoDetail = () => import('@/views/EducationInfoDetail');
const InterenePlan = () => import('@/views/IntervenePlan');
const IntervenePlanTumor = () => import('@/views/IntervenePlanTumor');
const IntervenePlanTumorPic = () => import('@/views/IntervenePlanTumorPic');
const NutritionTools = () => import('@/views/NutritionTools.vue');
const NutritionToolView = () => import('@/views/NutritionToolView.vue');
const CaseView = () => import('@/views/CaseView.vue');
const ClinicIndex = () => import('@/views/NutritionClinic/index.vue');
const ClinicListStyle = () => import('@/views/NutritionClinic/ListStyle.vue');
const DeliveryNote = () => import('@/views/Channel/DeliveryNote.vue');
const InspectionReport = () => import('@/views/Channel/InspectionReport.vue');
const AIGodownChat = () => import('@/views/AIGodownChat.vue');
const SPGChat = () => import('@/views/SPGChat.vue');

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		component: Home,
		redirect: '/conversations',
		children: [
			{
				path: 'conversations',
				component: Conversations,
				children: [
					{
						path: 'privatechat/:id',
						component: PrivateChat
					},
					{
						path: 'groupchat',
						component: GroupChat
					}
				]
			},
			{
				path: 'contacts',
				component: Contacts
			}
		]
	},
	{
		path: '/login',
		component: Login
	},
	{
		path: '/shareCard',
		component: ShareCard
	},
	{
		path: '/videolist',
		component: VideoList
	},
	{
		path: '/report',
		component: Report
	},
	{
		path: '/lossChange',
		component: LossChange
	},
	{
		path: '/rank',
		component: Rank
	},
	{
		path: '/sqrank',
		component: SQRank
	},
	{
		path: '/weightChart',
		component: WeightChart,
	},	{
		path: '/educationInfoDetail',
		component: EducationInfoDetail,
	},
	{
		path: '/interenePlan',
		component: InterenePlan
	},
	{
		path: '/interenePlanTumor',
		component: IntervenePlanTumor
	},{
		path: '/intervenePlanTumorPic',
		component: IntervenePlanTumorPic
	},{
		path: '/nutritionTools',
		name: 'NutritionTools',
		component: NutritionTools,
		meta: { keepAlive: true },

	},{
		path: '/nutritionToolView',
		name: 'NutritionToolView',
		component: NutritionToolView,
		meta: { keepAlive: false },
	},{
		path: '/caseView',
		name: 'CaseView',
		component: CaseView
	},{
		path: '/clinic/index',
		name: 'ClinicIndex',
		component: ClinicIndex
	},{
		path: '/clinic/listStyle',
		name: 'ClinicListStyle',
		component: ClinicListStyle
	},{
		path:'/deliveryNote',
		name:'DeliveryNote',
		component: DeliveryNote
	},{
		path:'/inspectionReport',
		name:'InspectionReport',
		component: InspectionReport,
		meta: { keepAlive: false },
	},{
		path: '/aiGodownChat',
		name: 'AIGodownChat',
		component: AIGodownChat,
		meta: { keepAlive: true },
	},{
		path: '/spgChat',
		name: 'SPGChat',
		component: SPGChat
	}
];

const router = new VueRouter({
	mode: 'history',
	routes,
});

router.beforeEach((to, from, next) => {
	Vue.prototype.globalData.currentUser = restApi.user;
	// console.log('Vue.prototype.globalData', Vue.prototype.globalData);
	next();
	// if (to.path !== '/login' && !Vue.prototype.globalData.currentUser) {
	//     next({path: '/login'})
	// } else next()
});

export default router;
